import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './ScoreChip.module.scss'

type ScoreChipProps = {
  score?: string | number
  size?: string
  theme?: string
  className?: string
}

export const ScoreChip = ({
  score,
  size,
  theme,
  className,
}: ScoreChipProps) => (
  <Box
    align="center"
    ariaLabel={score == null ? undefined : String(score)}
    ariaRole="presentation"
    className={cx(
      styles.chip,
      styles.size,
      styles.theme,
      size && styles[size],
      theme && styles[theme],
      className,
    )}
    justify="center"
    tagName="span"
  >
    {score}
  </Box>
)
